import * as THREE from 'three';

class DitheredMaterial extends THREE.ShaderMaterial {
  constructor() {
    super({
      uniforms: {
        baseColor: { value: new THREE.Color(0xffffff) }, // Set the base color to white
        opacity: { value: 0.6 },
      },
      vertexShader: `
        varying vec2 vUv;

        void main() {
          vUv = uv;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
      `,
      fragmentShader: `
        varying vec2 vUv;
        uniform vec3 baseColor;
        uniform float opacity;

        void main() {
          vec3 polyethyleneColor = vec3(0.92, 0.92, 0.92); // Define the polyethylene color
          float alpha = opacity;
          gl_FragColor = vec4(baseColor * polyethyleneColor, alpha);
        }
      `,
      transparent: true,
    });
  }
}

export default DitheredMaterial;
